import { useMutation, useQueryClient } from '@tanstack/react-query';
import { revokeInvite } from '../api/team.api';
import { teamKeys } from './team.keys';

/**
 * Invite-management mutations for admins (MYN-43): revoke a pending invite
 * (the UI's "Remove Member" action on an invite row). There is no resend
 * mutation — if a person still needs access, an admin removes the invite and
 * sends a new one rather than regenerating the old one.
 */
export function useInviteActions(entityId: string) {
  const queryClient = useQueryClient();
  const invalidate = () =>
    queryClient.invalidateQueries({ queryKey: teamKeys.invites(entityId) });

  const revoke = useMutation({
    mutationFn: (inviteId: string) => revokeInvite(inviteId),
    onSuccess: () => void invalidate(),
  });

  return { revoke };
}
